// Libraries and drafts saved before the Forms page scoped its keys by organisation
// belong to whichever org was in use; there has only ever been one, so they move to
// the first org that opens the page and are removed from the shared key, so no other
// org can see them.
const migratedOrgs = new Set()

export const migrateUnscopedStorage = (orgId, keys, scopedKeyFor) => {
    if (!orgId || migratedOrgs.has(orgId)) return
    migratedOrgs.add(orgId)
    try {
        for (const key of keys) {
            const legacy = localStorage.getItem(key)
            if (legacy === null) continue
            const scopedKey = scopedKeyFor(key, orgId)
            if (localStorage.getItem(scopedKey) === null) localStorage.setItem(scopedKey, legacy)
            localStorage.removeItem(key)
        }
    } catch (error) {
        // Storage unavailable (private mode): nothing to move.
    }
}
